import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords,
  canonical,
  type = 'website',
  image = 'https://customer-assets.emergentagent.com/job_havkin-health/artifacts/zyaf4i1j_ChatGPT%20Image%20Feb%2024%2C%202026%20at%2001_14_12%20PM.png'
}) => {
  const siteName = 'Havkin Urology';
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} | Men's Health Clinic Melbourne, FL`;
  const defaultDescription = "Confidential men's urology care in Melbourne, Florida. Expert treatment for erectile dysfunction, low testosterone, BPH, Peyronie's disease & vasectomy. Call (321) 500-4545.";
  const metaDescription = description || defaultDescription;
  const baseUrl = 'https://havkinurology.com';
  const canonicalUrl = canonical ? `${baseUrl}${canonical}` : baseUrl;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content={siteName} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
